// import React, { useState } from "react";
// import classNames from "classnames";
// import PropTypes from "prop-types";
// import { Collapse, Nav } from "react-bootstrap";
// import { NavLink, useLocation } from "react-router-dom";
// import NavbarVerticalMenuItem from "./NavbarVerticalMenuItem";
// import { useAppContext } from "Main";

// const CollapseItems = ({ route }) => {
//   const { pathname } = useLocation();

//   const openCollapse = (childrens) => {
//     const checkLink = (children) => {
//       if (children.to === pathname) {
//         return true;
//       }
//       return (
//         Object.prototype.hasOwnProperty.call(children, "children") &&
//         children.children.some(checkLink)
//       );
//     };
//     return childrens.some(checkLink);
//   };

//   const [open, setOpen] = useState(openCollapse(route?.children));

//   return (
//     <Nav.Item as="li">
//       <Nav.Link
//         onClick={() => {
//           setOpen(!open);
//         }}
//         title={route?.name}
//         className={classNames("dropdown-indicator cursor-pointer ps-1", {
//           "text-500": !route?.active,
//         })}
//         aria-expanded={open}
//         // {...route}
//       >
//         <NavbarVerticalMenuItem route={route} key={route.id} />
//       </Nav.Link>
//       <Collapse in={open}>
//         <Nav className="flex-column nav" as="ul" key={route.id}>
//           <NavbarVerticalMenu routes={route?.children} />
//         </Nav>
//       </Collapse>
//     </Nav.Item>
//   );
// };

// CollapseItems.propTypes = {
//   route: PropTypes.shape({
//     name: PropTypes.string,
//     // icon: PropTypes.string,
//     children: PropTypes.array,
//     active: PropTypes.bool,
//   }).isRequired,
// };

// const NavbarVerticalMenu = ({ routes }) => {
//   const {
//     config: { showBurgerMenu },
//     setConfig,
//   } = useAppContext();

//   const handleNavItemClick = () => {
//     if (showBurgerMenu) {
//       setConfig("showBurgerMenu", !showBurgerMenu);
//     }
//   };
//   return routes.map((route, index) => {
//     if (!route?.children) {
//       return (
//         <Nav.Item as="li" key={route?.name} onClick={handleNavItemClick}>
//           <NavLink
//             end={route?.exact}
//             to={route?.to}
//             title={route.name}
//             onClick={() =>
//               route.name === "Modal"
//                 ? setConfig("openAuthModal", true)
//                 : undefined
//             }
//             className={({ isActive }) =>
//               isActive && route?.to !== "#!" ? "active nav-link" : "nav-link"
//             }
//           >
//             <NavbarVerticalMenuItem route={route} key={index.toString()} />
//           </NavLink>
//         </Nav.Item>
//       );
//     }
//     return <CollapseItems route={route} key={route?.name} />;
//   });
// };

// NavbarVerticalMenu.propTypes = {
//   routes: PropTypes.arrayOf(PropTypes.shape(NavbarVerticalMenuItem.propTypes))
//     .isRequired,
// };

// export default NavbarVerticalMenu;

import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useAppContext } from "Main";

import { useState } from "react";
import classNames from "classnames";
import { Collapse, Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import NavbarVerticalMenuItem from "./NavbarVerticalMenuItem";

const CollapseItems = ({ route, depth, hover, collapsed }) => {
  const { pathname } = useLocation();
  // console.log("Navbar is collapsed:", collapsed);

  const openCollapse = (children) => {
    const checkLink = (child) => {
      if (child.to === pathname) return true;
      return Array.isArray(child.children) && child.children.some(checkLink);
    };
    return children?.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route?.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => setOpen(!open)}
        title={route?.name}
        className={classNames("dropdown-indicator cursor-pointer ", {
          "text-500": !route?.active,
        })}
        aria-expanded={open}
        // style={{ paddingLeft: `${depth * 12}px` }}
      >
        <NavbarVerticalMenuItem
          route={route}
          hover={hover}
          collapsed={collapsed}
        />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav ps-1" as="ul" key={route.id}>
          <NavbarVerticalMenu
            routes={route?.children}
            collapsed={collapsed}
            depth={depth + 1}
            hover={hover}
          />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string,
    children: PropTypes.array,
    active: PropTypes.bool,
  }).isRequired,
  depth: PropTypes.number,
  hover: PropTypes.bool,
  collapsed: PropTypes.bool,
};

const NavbarVerticalMenu = ({ routes, collapsed, hover, depth = 0 }) => {
  const {
    config: { showBurgerMenu },
    setConfig,
  } = useAppContext();

  const { pathname } = useLocation();

  // console.log(pathname, "Current Pathname");

  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig("showBurgerMenu", !showBurgerMenu);
    }
  };

  return routes.map((route, index) => {
    const hasChildren =
      Array.isArray(route.children) && route.children.length > 0;

    if (!hasChildren) {
      return (
        <Nav.Item
          as="li"
          key={route?.name || index}
          onClick={handleNavItemClick}
        >
          <NavLink
            end={route?.exact}
            to={route?.to}
            title={route.name}
            onClick={() =>
              route.name === "Modal"
                ? setConfig("openAuthModal", true)
                : undefined
            }
            className={({ isActive }) =>
              (isActive || pathname.startsWith(route?.to)) && route?.to !== "#!"
                ? "active nav-link"
                : "nav-link"
            }
            // style={{ paddingLeft: `${depth * 7}px` }}
          >
            <NavbarVerticalMenuItem
              route={route}
              collapsed={collapsed}
              hover={hover}
            />
          </NavLink>
        </Nav.Item>
      );
    }

    return (
      <CollapseItems
        route={route}
        key={route?.name || index}
        depth={depth + 1}
        collapsed={collapsed}
        hover={hover}
      />
    );
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      to: PropTypes.string,
      exact: PropTypes.bool,
      children: PropTypes.array,
      active: PropTypes.bool,
    })
  ).isRequired,
  collapsed: PropTypes.bool,
  depth: PropTypes.number,
};

export default NavbarVerticalMenu;
